export default __webpack_public_path__ + "static/media/SoilMoisture.c19d3f5c.webm";